/********************* Libaraies ***********************/
import ViewTicket from 'customer/orders/myBooking/component/viewTicket'
import { t } from 'i18next'
import moment from 'moment'
import React, { useCallback, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ActionsPanelComponent from 'shared/component/dxf-grid/actions-panel.component'
import DxfGrid from 'shared/component/dxf-grid/dxf-grid'
import OrderHeader from 'shared/component/orderHeader/orderHeader'
import { client } from 'shared/helpers/client'
import { formatDate } from 'shared/helpers/utils'
import useModal from 'shared/hooks/useModel'
import { downloadTicketBillPdf } from 'shared/services/reportService'
import Close from "shared/assets/images/svg/close_dialog.svg";
import { Column } from 'devextreme-react/data-grid'


const bookingColumn = [
    {
      id: "paxName",
      caption: t('my-booking.name'),
  
    },
    {
      id: "issueDate",
      caption: t('my-booking.issue'),
      cellRender: (data) => formatDate(data.value),
  
    },
    {
      id: "airLine",
      caption: t('my-booking.airline'),
  
    },
    {
      id: "ticketNumber",
      caption: t('my-booking.ticket'),
    },
    {
      id: "pnr",
      caption: t('my-booking.pnr'),
    },
    {
      id: "status",
      caption: t('my-booking.status'),
    },
    {
      id: "netTotal",
      caption: t('my-booking.total'),
    },
  ];
const BalanceModal = ({
    show,
    onHide,
    bookingOfficeSource,
    name,
    ...props
}) => {
    const {t} = useTranslation();
    const handleSortDate = useCallback(sortBy => {
        let start = moment(sortBy.from).format()
        let end = moment(sortBy.to).format()
        bookingOfficeSource.searchValue([
          ["StartDate", "=",`${start}`],
          "and",
          ["EndDate", "=",`${end}` ],
        ]);    
        bookingOfficeSource.reload();
    }, []);
    return (
        <div>
             <Modal
            fullscreen
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            className="all-modal Admin-modal"
        >
            <Modal.Body>
                <div className="header">
                        <h1 className="title office-title">{name}</h1>
                    <img src={Close} alt="close-modal" onClick={onHide} />
                </div>
                <hr className="hr" />
                <div className="">
            <div className="container-fluid">
              <OrderHeader  handleSortDate={handleSortDate} />
              <div className="dataTable">
              <DxfGrid dataSource={bookingOfficeSource}  >
            <Column dataField="transactionDate" caption={t('my-balance.recieve')}  cellRender={(c) => formatDate(c.value)} />
            <Column dataField="transactionEnglishName"  caption={t('my-balance.Transaction')}  />
            <Column dataField="ship" width='250' caption={t('my-balance.account')}/>
            <Column dataField="debit" caption={t('my-balance.debit')} />
            <Column dataField="credit" caption={t('my-balance.credit')} />
            <Column dataField="runningBalance" caption={t('my-balance.balance')}  calculateCellValue={(e)=> Math.round((e.runningBalance + Number.EPSILON) * 100) / 100} />
            <Column dataField="note" width='250' caption={t('my-balance.note')}/>
            <Column   cellRender={(cell) => <UserActions cell={cell}  />} />
          </DxfGrid>
              </div>
            </div>
          </div>
            </Modal.Body>
        </Modal>
        </div>
    )
}

export function UserActions({ cell }) {
  const row = cell.data;
  const [viewTicket, openTicket, closeTicket] = useModal(false);
  const [ticket, setTicket] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  async function handleViewTicket() {
    openTicket();
    const { response } = await client("/OwnerBooking/GetTicketDetails", {
      params: { TicketNumber: row?.ticketNumber },
    });
    if (response) {
      setTicket(response);
    }
  }
  async function handlePrint() {
    setIsPrinting(true);
    await downloadTicketBillPdf(row?.id);
    setIsPrinting(false);
  }
  function getActions() {
    return [
      {
        label: "View Ticket",
        action: () => handleViewTicket(),
      },
      { label: isPrinting ? "Printing..." : "Print", action: handlePrint },
      { label: "Send By E-mail", action: () => console.log(row) },
    ];
  }

  return (
    <>
      <ActionsPanelComponent actions={getActions()} />
      <ViewTicket ticketData={ticket} show={viewTicket} onHide={closeTicket} />
    </>
  );
}
export default BalanceModal
